<div *ngIf="loaderService.isLoading | async" class="loader">
  <p-progressBar mode="indeterminate" [style]="{ height: '1px' }"></p-progressBar>
</div>
<p-toast position="top-center" key="confirm" (onClose)="onClose()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="headless" let-closeFn="closeFn">
    <section class="flex p-3 gap-3 w-full bg-black-alpha-90 shadow-2" style="border-radius: 10px">
      <i class="pi pi-wifi text-primary-500 text-2xl"></i>
      <div class="flex flex-column gap-3 w-full">
        <p class="m-0 font-semibold text-base text-white">Offline</p>
        <p class="m-0 text-base text-500">You do not access to internet at the moment</p>
      </div>
    </section>
  </ng-template>
</p-toast>

<router-outlet></router-outlet>
